'use client';

import CreateAccountFields from './create-account-fields/create-account-fields';
import SignInFields from './sign-in-fields/sign-in-fields';

function AccountStepFields({ control, signInForm, register }) {
  return (
    <div>
      {signInForm ? (
        <SignInFields control={control} register={register} />
      ) : (
        <CreateAccountFields control={control} />
      )}
    </div>
  );
}

export default AccountStepFields;
